<template>
  <div>
    <header class="bar bar-nav">
      <a class="button button-link button-nav pull-left"  @click="gotolast()">
        <span class="icon icon-left"></span>返回
      </a>
      <!--<div class="button button-link button-nav pull-left">-->
        <!--<span class="icon icon-left" @click="goBack"></span>-->
      <!--</div>-->
      <h1 class='title'>我的订单</h1>
    </header>
    <div class="content" v-if="sessionInfo.customerInfo.ssoFlag === 0" style="overflow-x: hidden">
      <div class="buttons-tab">
        <a id ="t" href="#tab" class="tab-link button correlation-with-pay"><img :src="baseUrl+'all_orders.png'" class="img-width"></img></a>
        <a id ="t1" href="#tab1" class="tab-link button correlation-with-pay"><img class="img-width" :src="baseUrl+'wait_to_pay_1.png'"></img></a>
        <a id ="t2" href="#tab2" class="tab-link button correlation-with-pay"><img class="img-width" :src="baseUrl+'wait_receive.png'"></img></a>
        <a id ="t3" href="#tab3" class="tab-link button correlation-with-pay"><img class="img-width" :src="baseUrl+'complete.png'"></img></a>
        <a id ="t4" href="#tab4" class="tab-link button correlation-with-pay"><img class="img-width" :src="baseUrl+'cancel.png'"></img></a>
      </div>
      <div class="content-block">
        <div class="tabs">
          <div id="tab" class="tab">
            <myOrder :orderList = "waitPaidOrders" description="待支付" payFlag="true"
                     :button1Name="baseUrl+'cancel_order.png'" :button2Name = "baseUrl+'pay.png'"></myOrder>
            <!--<myOrder :orderList = "waitPaidOrders" :description="baseUrl+'wait_to_pay_3.png'" payFlag="true"-->
                     <!--:button1Name="baseUrl+'cancel_order.png'" :button2Name = "baseUrl+'pay.png'"></myOrder>-->
            <myOrder :orderList = "waitDeliverOrders" description="待收货"
                     :button1Name="baseUrl+'cancel_order.png'"  @response1="cancelOrderFromWaitPaid"
            ></myOrder>
            <myOrder :orderList = "finishedOrders" description="已完成"></myOrder>
            <myOrder :orderList = "canceledOrders" description="已取消"></myOrder>
          </div>
          <div id="tab1" class="tab" >
            <myOrder :orderList = "waitPaidOrders" description="待支付" payFlag="true"
                     :button1Name="baseUrl+'cancel_order.png'" :button2Name = "baseUrl+'pay.png'"
                     @response2="orderPay" @response1="cancelOrderFromWaitPaid"></myOrder>
          </div>
          <div id="tab2" class="tab">
            <myOrder :orderList = "waitDeliverOrders" description="待收货"
                     :button1Name="baseUrl+'cancel_order.png'"  @response1="cancelOrderFromWaitPaid"
            ></myOrder>
          </div>
          <div id="tab3" class="tab">
            <myOrder :orderList = "finishedOrders" description="已完成"></myOrder>
          </div>
          <div id="tab4" class="tab">
            <myOrder :orderList = "canceledOrders" description="已取消"></myOrder>
          </div>
        </div>
      </div>
    </div>
    <div class="content" v-else style="overflow-x: hidden;">
      <div class="buttons-tab">
        <a id ="t10" href="#tab10" class="tab-link button">审核失败</a>
        <a id ="t6" href="#tab6" class="tab-link button">待审核</a>
        <a id ="t7" href="#tab7" class="tab-link button">报价完成</a>
        <a id ="t8" href="#tab8" class="tab-link button">录入完成</a>
        <a id ="t9" href="#tab9" class="tab-link button">已签署</a>
      </div>
      <div class="content-block">
        <div class="tabs" >
          <div id="tab10" class="tab"  >
            <myOrder :orderList = "failAuditOrders" description="审核失败"
                     button4Name="审核意见" button5Name="重新购买"   ></myOrder>
          </div>
          <div id="tab6" class="tab"  >
            <myOrder :orderList = "waitAuditOrders" description="待审核"
                     button3Name = '价格明细'  ></myOrder>
          </div>
          <div id="tab7" class="tab" >
            <myOrder :orderList = "quoteCompletedOrders" description="报价完成"
                     button3Name="价格明细" button4Name="审核意见"
                     ></myOrder>
          </div>
          <div id="tab8" class="tab" >
            <myOrder :orderList = "completeOrders" description="录入完成"
                     button3Name="价格明细" button4Name="审核意见">

            </myOrder>
          </div>
          <div id="tab9" class="tab"  >
            <myOrder :orderList = "waitSignOrders" description="待签署"  button3Name="价格明细" button4Name="审核意见"></myOrder>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import $ from 'jquery'
  import myOrder from './child/MyOrder.vue'
  import {mapState, mapMutations} from 'vuex'
  export default {
    data () {
      return {
        waitPaidOrders: [],
        waitDeliverOrders: [],
        finishedOrders: [],
        canceledOrders: [],
        waitSignOrders: [],
        completeOrders: [],
        quoteCompletedOrders: [],
        waitAuditOrders: [],
        failAuditOrders: [],
        baseUrl: '/emktResources/resocurces/img/pay/'
      }
    },
    components: {
      myOrder
    },
    mounted () {
      $('#t' + this.$route.query.id).addClass('active')
      $('#tab' + this.$route.query.id).addClass('active')
      if (this.myOrder) {
        this.waitPaidOrders = this.myOrder.waitPaidOrders
        this.waitDeliverOrders = this.myOrder.waitDeliverOrders
        this.myOrder.finishedOrders.forEach(function (item) {
          item.isFinished = true
        })
        this.finishedOrders = this.myOrder.finishedOrders
        this.canceledOrders = this.myOrder.canceledOrders

        this.waitSignOrders = this.myOrder.waitSignOrders
        this.completeOrders = this.myOrder.completeOrders
        this.quoteCompletedOrders = this.myOrder.quoteCompletedOrders
        this.waitAuditOrders = this.myOrder.waitAuditOrders
        this.failAuditOrders = this.myOrder.failAuditOrders
      }
    },
    computed: {
      ...mapState([
        'myOrder', 'sessionInfo'
      ])
    },
    watch: {
    },
    methods: {
      ...mapMutations([
        'SET_CURRENT_WAITPAY_ORDER', 'SET_CURRENT_WAITPAY_ORDER'
      ]),
      goBack () {
        this.$router.go(-1)
      },
      cancelOrderFromWaitPaid (order) {
        var self = this
        this.gcapi('orderCancel', {id: order.id}).then(data => {
          let index = self.waitPaidOrders.indexOf(order)
          if (index >= 0) {
            self.waitPaidOrders.splice(index, 1)
          } else {
            index = self.waitDeliverOrders.indexOf(order)
            if (index >= 0) {
              self.waitDeliverOrders.splice(index, 1)
            }
          }
          self.canceledOrders.unshift(order)
          $.toast('取消成功')
        })
      },
      orderPay (order) {
        // this.gcapi('getWaitPayOrderInfoByOrderId', order.id).then(res => {
        //   if (res && res.body.result) {
        //     const waitPayOrder = res.body.result
        //     this.SET_CURRENT_WAITPAY_ORDER(waitPayOrder)
        //     this.$router.push({name: 'WeappOrderConfirmation'})
        //   }
        // })
        let clientOrder = order
        this.SET_CURRENT_WAITPAY_ORDER(clientOrder)
        this.$router.replace({name: 'WeappOrderConfirmation'})
        // this.$router.push({name: 'orderContent', params: {order: clientOrder}})
      },
      gotolast () {
        this.$router.go(-1)
      }
    }
  }
</script>
<style>
  .correlation-with-pay {
    display: flex;
    align-items: center;
  }

  .img-width {
    width: 2.5rem;
  }
</style>



// WEBPACK FOOTER //
// AllOrder.vue?c12ce334